export { default } from '@/pages/Home/EmergeHome';
